"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventType = void 0;
/**
 * Тип события
 */
var EventType;
(function (EventType) {
    EventType["CONTACTS_UPDATED"] = "CONTACTS_UPDATED";
    EventType["USER_AUTHENTICATED"] = "USER_AUTHENTICATED";
    EventType["MODAL_CLOSED"] = "MODAL_CLOSED";
    EventType["USER_VERIFIED"] = "USER_VERIFIED";
})(EventType = exports.EventType || (exports.EventType = {}));
